import { createContext as e, forwardRef as r, createElement as t, Children as n, memo as a } from "react";

function o(e, r) {
  return r || (r = e.slice(0)), e.raw = r, e;
}

var i = function () {
  function e(e) {
    this.isSpeedy = void 0 === e.speedy ? "production" === process.env.NODE_ENV : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.before = null;
  }

  var r = e.prototype;
  return r.insert = function (e) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) == 0) {
      var r = function (e) {
        var r = document.createElement("style");
        return r.setAttribute("data-emotion", e.key), void 0 !== e.nonce && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r;
      }(this);

      this.container.insertBefore(r, 0 === this.tags.length ? this.before : this.tags[this.tags.length - 1].nextSibling), this.tags.push(r);
    }

    var t = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var n = function (e) {
        if (e.sheet) return e.sheet;

        for (var r = 0; r < document.styleSheets.length; r++) {
          if (document.styleSheets[r].ownerNode === e) return document.styleSheets[r];
        }
      }(t);

      try {
        var a = 105 === e.charCodeAt(1) && 64 === e.charCodeAt(0);
        n.insertRule(e, a ? 0 : n.cssRules.length);
      } catch (r) {
        "production" !== process.env.NODE_ENV && console.warn('There was a problem inserting the following rule: "' + e + '"', r);
      }
    } else t.appendChild(document.createTextNode(e));

    this.ctr++;
  }, r.flush = function () {
    this.tags.forEach(function (e) {
      return e.parentNode.removeChild(e);
    }), this.tags = [], this.ctr = 0;
  }, e;
}();

function s(e) {
  function r(e, r, n) {
    var a = r.trim().split(h);
    r = a;
    var o = a.length,
        i = e.length;

    switch (i) {
      case 0:
      case 1:
        var s = 0;

        for (e = 0 === i ? "" : e[0] + " "; s < o; ++s) {
          r[s] = t(e, r[s], n).trim();
        }

        break;

      default:
        var c = s = 0;

        for (r = []; s < o; ++s) {
          for (var l = 0; l < i; ++l) {
            r[c++] = t(e[l] + " ", a[s], n).trim();
          }
        }

    }

    return r;
  }

  function t(e, r, t) {
    var n = r.charCodeAt(0);

    switch (33 > n && (n = (r = r.trim()).charCodeAt(0)), n) {
      case 38:
        return r.replace(v, "$1" + e.trim());

      case 58:
        return e.trim() + r.replace(v, "$1" + e.trim());

      default:
        if (0 < 1 * t && 0 < r.indexOf("\f")) return r.replace(v, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
    }

    return e + r;
  }

  function n(e, r, t, o) {
    var i = e + ";",
        s = 2 * r + 3 * t + 4 * o;

    if (944 === s) {
      e = i.indexOf(":", 9) + 1;
      var c = i.substring(e, i.length - 1).trim();
      return c = i.substring(0, e).trim() + c + ";", 1 === S || 2 === S && a(c, 1) ? "-webkit-" + c + c : c;
    }

    if (0 === S || 2 === S && !a(i, 1)) return i;

    switch (s) {
      case 1015:
        return 97 === i.charCodeAt(10) ? "-webkit-" + i + i : i;

      case 951:
        return 116 === i.charCodeAt(3) ? "-webkit-" + i + i : i;

      case 963:
        return 110 === i.charCodeAt(5) ? "-webkit-" + i + i : i;

      case 1009:
        if (100 !== i.charCodeAt(4)) break;

      case 969:
      case 942:
        return "-webkit-" + i + i;

      case 978:
        return "-webkit-" + i + "-moz-" + i + i;

      case 1019:
      case 983:
        return "-webkit-" + i + "-moz-" + i + "-ms-" + i + i;

      case 883:
        if (45 === i.charCodeAt(8)) return "-webkit-" + i + i;
        if (0 < i.indexOf("image-set(", 11)) return i.replace(x, "$1-webkit-$2") + i;
        break;

      case 932:
        if (45 === i.charCodeAt(4)) switch (i.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + i.replace("-grow", "") + "-webkit-" + i + "-ms-" + i.replace("grow", "positive") + i;

          case 115:
            return "-webkit-" + i + "-ms-" + i.replace("shrink", "negative") + i;

          case 98:
            return "-webkit-" + i + "-ms-" + i.replace("basis", "preferred-size") + i;
        }
        return "-webkit-" + i + "-ms-" + i + i;

      case 964:
        return "-webkit-" + i + "-ms-flex-" + i + i;

      case 1023:
        if (99 !== i.charCodeAt(8)) break;
        return "-webkit-box-pack" + (c = i.substring(i.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + i + "-ms-flex-pack" + c + i;

      case 1005:
        return f.test(i) ? i.replace(d, ":-webkit-") + i.replace(d, ":-moz-") + i : i;

      case 1e3:
        switch (r = (c = i.substring(13).trim()).indexOf("-") + 1, c.charCodeAt(0) + c.charCodeAt(r)) {
          case 226:
            c = i.replace(w, "tb");
            break;

          case 232:
            c = i.replace(w, "tb-rl");
            break;

          case 220:
            c = i.replace(w, "lr");
            break;

          default:
            return i;
        }

        return "-webkit-" + i + "-ms-" + c + i;

      case 1017:
        if (-1 === i.indexOf("sticky", 9)) break;

      case 975:
        switch (r = (i = e).length - 10, s = (c = (33 === i.charCodeAt(r) ? i.substring(0, r) : i).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | c.charCodeAt(7))) {
          case 203:
            if (111 > c.charCodeAt(8)) break;

          case 115:
            i = i.replace(c, "-webkit-" + c) + ";" + i;
            break;

          case 207:
          case 102:
            i = i.replace(c, "-webkit-" + (102 < s ? "inline-" : "") + "box") + ";" + i.replace(c, "-webkit-" + c) + ";" + i.replace(c, "-ms-" + c + "box") + ";" + i;
        }

        return i + ";";

      case 938:
        if (45 === i.charCodeAt(5)) switch (i.charCodeAt(6)) {
          case 105:
            return c = i.replace("-items", ""), "-webkit-" + i + "-webkit-box-" + c + "-ms-flex-" + c + i;

          case 115:
            return "-webkit-" + i + "-ms-flex-item-" + i.replace(E, "") + i;

          default:
            return "-webkit-" + i + "-ms-flex-line-pack" + i.replace("align-content", "").replace(E, "") + i;
        }
        break;

      case 973:
      case 989:
        if (45 !== i.charCodeAt(3) || 122 === i.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === C.test(e)) return 115 === (c = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? n(e.replace("stretch", "fill-available"), r, t, o).replace(":fill-available", ":stretch") : i.replace(c, "-webkit-" + c) + i.replace(c, "-moz-" + c.replace("fill-", "")) + i;
        break;

      case 962:
        if (i = "-webkit-" + i + (102 === i.charCodeAt(5) ? "-ms-" + i : "") + i, 211 === t + o && 105 === i.charCodeAt(13) && 0 < i.indexOf("transform", 10)) return i.substring(0, i.indexOf(";", 27) + 1).replace(p, "$1-webkit-$2") + i;
    }

    return i;
  }

  function a(e, r) {
    var t = e.indexOf(1 === r ? ":" : "{"),
        n = e.substring(0, 3 !== r ? t : 10);
    return t = e.substring(t + 1, e.length - 1), I(2 !== r ? n : n.replace(A, "$1"), t, r);
  }

  function o(e, r) {
    var t = n(r, r.charCodeAt(0), r.charCodeAt(1), r.charCodeAt(2));
    return t !== r + ";" ? t.replace(k, " or ($1)").substring(4) : "(" + r + ")";
  }

  function i(e, r, t, n, a, o, i, s, l, u) {
    for (var d, f = 0, p = r; f < $; ++f) {
      switch (d = V[f].call(c, e, p, t, n, a, o, i, s, l, u)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          p = d;
      }
    }

    if (p !== r) return p;
  }

  function s(e) {
    return void 0 !== (e = e.prefix) && (I = null, e ? "function" != typeof e ? S = 1 : (S = 2, I = e) : S = 0), s;
  }

  function c(e, t) {
    var s = e;

    if (33 > s.charCodeAt(0) && (s = s.trim()), s = [s], 0 < $) {
      var c = i(-1, t, s, s, O, N, 0, 0, 0, 0);
      void 0 !== c && "string" == typeof c && (t = c);
    }

    var d = function e(t, s, c, d, f) {
      for (var p, h, v, w, k, E = 0, A = 0, C = 0, x = 0, V = 0, I = 0, T = v = p = 0, z = 0, R = 0, L = 0, P = 0, M = c.length, q = M - 1, Y = "", G = "", U = "", W = ""; z < M;) {
        if (h = c.charCodeAt(z), z === q && 0 !== A + x + C + E && (0 !== A && (h = 47 === A ? 10 : 47), x = C = E = 0, M++, q++), 0 === A + x + C + E) {
          if (z === q && (0 < R && (Y = Y.replace(u, "")), 0 < Y.trim().length)) {
            switch (h) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;

              default:
                Y += c.charAt(z);
            }

            h = 59;
          }

          switch (h) {
            case 123:
              for (p = (Y = Y.trim()).charCodeAt(0), v = 1, P = ++z; z < M;) {
                switch (h = c.charCodeAt(z)) {
                  case 123:
                    v++;
                    break;

                  case 125:
                    v--;
                    break;

                  case 47:
                    switch (h = c.charCodeAt(z + 1)) {
                      case 42:
                      case 47:
                        e: {
                          for (T = z + 1; T < q; ++T) {
                            switch (c.charCodeAt(T)) {
                              case 47:
                                if (42 === h && 42 === c.charCodeAt(T - 1) && z + 2 !== T) {
                                  z = T + 1;
                                  break e;
                                }

                                break;

                              case 10:
                                if (47 === h) {
                                  z = T + 1;
                                  break e;
                                }

                            }
                          }

                          z = T;
                        }

                    }

                    break;

                  case 91:
                    h++;

                  case 40:
                    h++;

                  case 34:
                  case 39:
                    for (; z++ < q && c.charCodeAt(z) !== h;) {
                      ;
                    }

                }

                if (0 === v) break;
                z++;
              }

              switch (v = c.substring(P, z), 0 === p && (p = (Y = Y.replace(l, "").trim()).charCodeAt(0)), p) {
                case 64:
                  switch (0 < R && (Y = Y.replace(u, "")), h = Y.charCodeAt(1)) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      R = s;
                      break;

                    default:
                      R = D;
                  }

                  if (P = (v = e(s, R, v, h, f + 1)).length, 0 < $ && (k = i(3, v, R = r(D, Y, L), s, O, N, P, h, f, d), Y = R.join(""), void 0 !== k && 0 === (P = (v = k.trim()).length) && (h = 0, v = "")), 0 < P) switch (h) {
                    case 115:
                      Y = Y.replace(y, o);

                    case 100:
                    case 109:
                    case 45:
                      v = Y + "{" + v + "}";
                      break;

                    case 107:
                      v = (Y = Y.replace(b, "$1 $2")) + "{" + v + "}", v = 1 === S || 2 === S && a("@" + v, 3) ? "@-webkit-" + v + "@" + v : "@" + v;
                      break;

                    default:
                      v = Y + v, 112 === d && (G += v, v = "");
                  } else v = "";
                  break;

                default:
                  v = e(s, r(s, Y, L), v, d, f + 1);
              }

              U += v, v = L = R = T = p = 0, Y = "", h = c.charCodeAt(++z);
              break;

            case 125:
            case 59:
              if (1 < (P = (Y = (0 < R ? Y.replace(u, "") : Y).trim()).length)) switch (0 === T && (p = Y.charCodeAt(0), 45 === p || 96 < p && 123 > p) && (P = (Y = Y.replace(" ", ":")).length), 0 < $ && void 0 !== (k = i(1, Y, s, t, O, N, G.length, d, f, d)) && 0 === (P = (Y = k.trim()).length) && (Y = "\0\0"), p = Y.charCodeAt(0), h = Y.charCodeAt(1), p) {
                case 0:
                  break;

                case 64:
                  if (105 === h || 99 === h) {
                    W += Y + c.charAt(z);
                    break;
                  }

                default:
                  58 !== Y.charCodeAt(P - 1) && (G += n(Y, p, h, Y.charCodeAt(2)));
              }
              L = R = T = p = 0, Y = "", h = c.charCodeAt(++z);
          }
        }

        switch (h) {
          case 13:
          case 10:
            47 === A ? A = 0 : 0 === 1 + p && 107 !== d && 0 < Y.length && (R = 1, Y += "\0"), 0 < $ * j && i(0, Y, s, t, O, N, G.length, d, f, d), N = 1, O++;
            break;

          case 59:
          case 125:
            if (0 === A + x + C + E) {
              N++;
              break;
            }

          default:
            switch (N++, w = c.charAt(z), h) {
              case 9:
              case 32:
                if (0 === x + E + A) switch (V) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    w = "";
                    break;

                  default:
                    32 !== h && (w = " ");
                }
                break;

              case 0:
                w = "\\0";
                break;

              case 12:
                w = "\\f";
                break;

              case 11:
                w = "\\v";
                break;

              case 38:
                0 === x + A + E && (R = L = 1, w = "\f" + w);
                break;

              case 108:
                if (0 === x + A + E + _ && 0 < T) switch (z - T) {
                  case 2:
                    112 === V && 58 === c.charCodeAt(z - 3) && (_ = V);

                  case 8:
                    111 === I && (_ = I);
                }
                break;

              case 58:
                0 === x + A + E && (T = z);
                break;

              case 44:
                0 === A + C + x + E && (R = 1, w += "\r");
                break;

              case 34:
              case 39:
                0 === A && (x = x === h ? 0 : 0 === x ? h : x);
                break;

              case 91:
                0 === x + A + C && E++;
                break;

              case 93:
                0 === x + A + C && E--;
                break;

              case 41:
                0 === x + A + E && C--;
                break;

              case 40:
                if (0 === x + A + E) {
                  if (0 === p) switch (2 * V + 3 * I) {
                    case 533:
                      break;

                    default:
                      p = 1;
                  }
                  C++;
                }

                break;

              case 64:
                0 === A + C + x + E + T + v && (v = 1);
                break;

              case 42:
              case 47:
                if (!(0 < x + E + C)) switch (A) {
                  case 0:
                    switch (2 * h + 3 * c.charCodeAt(z + 1)) {
                      case 235:
                        A = 47;
                        break;

                      case 220:
                        P = z, A = 42;
                    }

                    break;

                  case 42:
                    47 === h && 42 === V && P + 2 !== z && (33 === c.charCodeAt(P + 2) && (G += c.substring(P, z + 1)), w = "", A = 0);
                }
            }

            0 === A && (Y += w);
        }

        I = V, V = h, z++;
      }

      if (0 < (P = G.length)) {
        if (R = s, 0 < $ && void 0 !== (k = i(2, G, R, t, O, N, P, d, f, d)) && 0 === (G = k).length) return W + G + U;

        if (G = R.join(",") + "{" + G + "}", 0 != S * _) {
          switch (2 !== S || a(G, 2) || (_ = 0), _) {
            case 111:
              G = G.replace(m, ":-moz-$1") + G;
              break;

            case 112:
              G = G.replace(g, "::-webkit-input-$1") + G.replace(g, "::-moz-$1") + G.replace(g, ":-ms-input-$1") + G;
          }

          _ = 0;
        }
      }

      return W + G + U;
    }(D, s, t, 0, 0);

    return 0 < $ && void 0 !== (c = i(-2, d, s, s, O, N, d.length, 0, 0, 0)) && (d = c), _ = 0, N = O = 1, d;
  }

  var l = /^\0+/g,
      u = /[\0\r\f]/g,
      d = /: */g,
      f = /zoo|gra/,
      p = /([,: ])(transform)/g,
      h = /,\r+?/g,
      v = /([\t\r\n ])*\f?&/g,
      b = /@(k\w+)\s*(\S*)\s*/,
      g = /::(place)/g,
      m = /:(read-only)/g,
      w = /[svh]\w+-[tblr]{2}/,
      y = /\(\s*(.*)\s*\)/g,
      k = /([\s\S]*?);/g,
      E = /-self|flex-/g,
      A = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      C = /stretch|:\s*\w+\-(?:conte|avail)/,
      x = /([^-])(image-set\()/,
      N = 1,
      O = 1,
      _ = 0,
      S = 1,
      D = [],
      V = [],
      $ = 0,
      I = null,
      j = 0;
  return c.use = function e(r) {
    switch (r) {
      case void 0:
      case null:
        $ = V.length = 0;
        break;

      default:
        if ("function" == typeof r) V[$++] = r;else if ("object" == typeof r) for (var t = 0, n = r.length; t < n; ++t) {
          e(r[t]);
        } else j = 0 | !!r;
    }

    return e;
  }, c.set = s, void 0 !== e && s(e), c;
}

function c(e) {
  e && l.current.insert(e + "}");
}

var l = {
  current: null
},
    u = function u(e, r, t, n, a, o, i, s, _u, d) {
  switch (e) {
    case 1:
      switch (r.charCodeAt(0)) {
        case 64:
          return l.current.insert(r + ";"), "";

        case 108:
          if (98 === r.charCodeAt(2)) return "";
      }

      break;

    case 2:
      if (0 === s) return r + "/*|*/";
      break;

    case 3:
      switch (s) {
        case 102:
        case 112:
          return l.current.insert(t[0] + r), "";

        default:
          return r + (0 === d ? "/*|*/" : "");
      }

    case -2:
      r.split("/*|*/}").forEach(c);
  }
};

function d(e, r, t) {
  var n = "";
  return t.split(" ").forEach(function (t) {
    void 0 !== e[t] ? r.push(e[t]) : n += t + " ";
  }), n;
}

var f,
    p,
    h = function h(e, r, t) {
  var n = e.key + "-" + r.name;

  if (!1 === t && void 0 === e.registered[n] && (e.registered[n] = r.styles), void 0 === e.inserted[r.name]) {
    var a = r;

    do {
      e.insert("." + n, a, e.sheet, !0), a = a.next;
    } while (void 0 !== a);
  }
},
    v = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
},
    b = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
    g = /[A-Z]|^ms/g,
    m = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
    w = function w(e) {
  return 45 === e.charCodeAt(1);
},
    y = function y(e) {
  return null != e && "boolean" != typeof e;
},
    k = (f = function f(e) {
  return w(e) ? e : e.replace(g, "-$&").toLowerCase();
}, p = {}, function (e) {
  return void 0 === p[e] && (p[e] = f(e)), p[e];
}),
    E = function E(e, r) {
  switch (e) {
    case "animation":
    case "animationName":
      if ("string" == typeof r) return r.replace(m, function (e, r, t) {
        return $ = {
          name: r,
          styles: t,
          next: $
        }, r;
      });
  }

  return 1 === v[e] || w(e) || "number" != typeof r || 0 === r ? r : r + "px";
};

if ("production" !== process.env.NODE_ENV) {
  var A = /(attr|calc|counters?|url)\(/,
      C = ["normal", "none", "counter", "open-quote", "close-quote", "no-open-quote", "no-close-quote", "initial", "inherit", "unset"],
      x = E,
      N = /^-ms-/,
      O = /-(.)/g,
      _ = {};

  E = function E(e, r) {
    "content" === e && ("string" != typeof r || -1 === C.indexOf(r) && !A.test(r) && (r.charAt(0) !== r.charAt(r.length - 1) || '"' !== r.charAt(0) && "'" !== r.charAt(0))) && console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + r + "\"'`");
    var t = x(e, r);
    return "" === t || w(e) || -1 === e.indexOf("-") || void 0 !== _[e] || (_[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(N, "ms-").replace(O, function (e, r) {
      return r.toUpperCase();
    }) + "?")), t;
  };
}

var S = !0;

function D(e, r, t, n) {
  if (null == t) return "";

  if (void 0 !== t.__emotion_styles) {
    if ("production" !== process.env.NODE_ENV && "NO_COMPONENT_SELECTOR" === t.toString()) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
    return t;
  }

  switch (typeof t) {
    case "boolean":
      return "";

    case "object":
      if (1 === t.anim) return $ = {
        name: t.name,
        styles: t.styles,
        next: $
      }, t.name;

      if (void 0 !== t.styles) {
        var a = t.next;
        if (void 0 !== a) for (; void 0 !== a;) {
          $ = {
            name: a.name,
            styles: a.styles,
            next: $
          }, a = a.next;
        }
        var o = t.styles + ";";
        return "production" !== process.env.NODE_ENV && void 0 !== t.map && (o += t.map), o;
      }

      return function (e, r, t) {
        var n = "";
        if (Array.isArray(t)) for (var a = 0; a < t.length; a++) {
          n += D(e, r, t[a], !1);
        } else for (var o in t) {
          var i = t[o];
          if ("object" != typeof i) null != r && void 0 !== r[i] ? n += o + "{" + r[i] + "}" : y(i) && (n += k(o) + ":" + E(o, i) + ";");else {
            if ("NO_COMPONENT_SELECTOR" === o && "production" !== process.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");

            if (!Array.isArray(i) || "string" != typeof i[0] || null != r && void 0 !== r[i[0]]) {
              var s = D(e, r, i, !1);

              switch (o) {
                case "animation":
                case "animationName":
                  n += k(o) + ":" + s + ";";
                  break;

                default:
                  "production" !== process.env.NODE_ENV && "undefined" === o && console.error("You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key)."), n += o + "{" + s + "}";
              }
            } else for (var c = 0; c < i.length; c++) {
              y(i[c]) && (n += k(o) + ":" + E(o, i[c]) + ";");
            }
          }
        }
        return n;
      }(e, r, t);

    case "function":
      if (void 0 !== e) {
        var i = $,
            s = t(e);
        return $ = i, D(e, r, s, n);
      }

      "production" !== process.env.NODE_ENV && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;

    case "string":
      if ("production" !== process.env.NODE_ENV) {
        var c = [],
            l = t.replace(m, function (e, r, t) {
          var n = "animation" + c.length;
          return c.push("const " + n + " = keyframes`" + t.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + n + "}";
        });
        c.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(c, ["`" + l + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\ncss`" + l + "`");
      }

  }

  if (null == r) return t;
  var u = r[t];
  return "production" !== process.env.NODE_ENV && n && S && void 0 !== u && (console.error("Interpolating a className from css`` is not recommended and will cause problems with composition.\nInterpolating a className from css`` will be completely unsupported in a future major version of Emotion"), S = !1), void 0 === u || n ? t : u;
}

var V,
    $,
    I = /label:\s*([^\s;\n{]+)\s*;/g;
"production" !== process.env.NODE_ENV && (V = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//);

var j = function j(e, r, t) {
  if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
  var n = !0,
      a = "";
  $ = void 0;
  var o,
      i = e[0];
  null == i || void 0 === i.raw ? (n = !1, a += D(t, r, i, !1)) : ("production" !== process.env.NODE_ENV && void 0 === i[0] && console.error(b), a += i[0]);

  for (var s = 1; s < e.length; s++) {
    a += D(t, r, e[s], 46 === a.charCodeAt(a.length - 1)), n && ("production" !== process.env.NODE_ENV && void 0 === i[s] && console.error(b), a += i[s]);
  }

  "production" !== process.env.NODE_ENV && (a = a.replace(V, function (e) {
    return o = e, "";
  })), I.lastIndex = 0;

  for (var c, l = ""; null !== (c = I.exec(a));) {
    l += "-" + c[1];
  }

  var u = function (e) {
    for (var r, t = 0, n = 0, a = e.length; a >= 4; ++n, a -= 4) {
      r = 1540483477 * (65535 & (r = 255 & e.charCodeAt(n) | (255 & e.charCodeAt(++n)) << 8 | (255 & e.charCodeAt(++n)) << 16 | (255 & e.charCodeAt(++n)) << 24)) + (59797 * (r >>> 16) << 16), t = 1540483477 * (65535 & (r ^= r >>> 24)) + (59797 * (r >>> 16) << 16) ^ 1540483477 * (65535 & t) + (59797 * (t >>> 16) << 16);
    }

    switch (a) {
      case 3:
        t ^= (255 & e.charCodeAt(n + 2)) << 16;

      case 2:
        t ^= (255 & e.charCodeAt(n + 1)) << 8;

      case 1:
        t = 1540483477 * (65535 & (t ^= 255 & e.charCodeAt(n))) + (59797 * (t >>> 16) << 16);
    }

    return (((t = 1540483477 * (65535 & (t ^= t >>> 13)) + (59797 * (t >>> 16) << 16)) ^ t >>> 15) >>> 0).toString(36);
  }(a) + l;

  return "production" !== process.env.NODE_ENV ? {
    name: u,
    styles: a,
    map: o,
    next: $,
    toString: function toString() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: u,
    styles: a,
    next: $
  };
};

function T() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++) {
    r[t] = arguments[t];
  }

  return j(r);
}

var z = e("undefined" != typeof HTMLElement ? function (e) {
  void 0 === e && (e = {});
  var r,
      t = e.key || "css";
  void 0 !== e.prefix && (r = {
    prefix: e.prefix
  });
  var n = new s(r);
  if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(t)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var a,
      o = {};
  a = e.container || document.head;
  var c,
      d = document.querySelectorAll("style[data-emotion-" + t + "]");

  if (Array.prototype.forEach.call(d, function (e) {
    e.getAttribute("data-emotion-" + t).split(" ").forEach(function (e) {
      o[e] = !0;
    }), e.parentNode !== a && a.appendChild(e);
  }), n.use(e.stylisPlugins)(u), c = function c(e, r, t, a) {
    var o = r.name;

    if (l.current = t, "production" !== process.env.NODE_ENV && void 0 !== r.map) {
      var i = r.map;
      l.current = {
        insert: function insert(e) {
          t.insert(e + i);
        }
      };
    }

    n(e, r.styles), a && (h.inserted[o] = !0);
  }, "production" !== process.env.NODE_ENV) {
    var f = /\/\*/g,
        p = /\*\//g;
    n.use(function (e, r) {
      switch (e) {
        case -1:
          for (; f.test(r);) {
            if (p.lastIndex = f.lastIndex, !p.test(r)) throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            f.lastIndex = p.lastIndex;
          }

          f.lastIndex = 0;
      }
    }), n.use(function (e, r, t) {
      switch (e) {
        case -1:
          var n = r.match(/(:first|:nth|:nth-last)-child/g);
          n && !0 !== h.compat && n.forEach(function (e) {
            var t = new RegExp(e + ".*\\/\\* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason \\*\\/").test(r);
            e && !t && console.error('The pseudo class "' + e + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + e.split("-child")[0] + '-of-type".');
          });
      }
    });
  }

  var h = {
    key: t,
    sheet: new i({
      key: t,
      container: a,
      nonce: e.nonce,
      speedy: e.speedy
    }),
    nonce: e.nonce,
    inserted: o,
    registered: {},
    insert: c
  };
  return h;
}() : null),
    R = e({}),
    L = function L(e) {
  return r(function (r, n) {
    return t(z.Consumer, null, function (t) {
      return e(r, t, n);
    });
  });
},
    P = function P(e) {
  return e.replace(/\$/g, "-");
},
    M = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__",
    q = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__",
    Y = Object.prototype.hasOwnProperty,
    G = function G(e, r, n, a) {
  var o = null === n ? r.css : r.css(n);
  "string" == typeof o && void 0 !== e.registered[o] && (o = e.registered[o]);
  var i = r[M],
      s = [o],
      c = "";
  "string" == typeof r.className ? c = d(e.registered, s, r.className) : null != r.className && (c = r.className + " ");
  var l = j(s);

  if ("production" !== process.env.NODE_ENV && -1 === l.name.indexOf("-")) {
    var u = r[q];
    u && (l = j([l, "label:" + u + ";"]));
  }

  h(e, l, "string" == typeof i), c += e.key + "-" + l.name;
  var f = {};

  for (var p in r) {
    !Y.call(r, p) || "css" === p || p === M || "production" !== process.env.NODE_ENV && p === q || (f[p] = r[p]);
  }

  return f.ref = a, f.className = c, t(i, f);
},
    U = L(function (e, r, n) {
  return "function" == typeof e.css ? t(R.Consumer, null, function (t) {
    return G(r, e, t, n);
  }) : G(r, e, null, n);
});

"production" !== process.env.NODE_ENV && (U.displayName = "EmotionCssPropInternal");

var W = function W(e, r) {
  var n = arguments;
  if (null == r || !Y.call(r, "css")) return t.apply(void 0, n);
  if ("production" !== process.env.NODE_ENV && "string" == typeof r.css && -1 !== r.css.indexOf(":")) throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + r.css + "`");
  var a = n.length,
      o = new Array(a);
  o[0] = U;
  var i = {};

  for (var s in r) {
    Y.call(r, s) && (i[s] = r[s]);
  }

  if (i[M] = e, "production" !== process.env.NODE_ENV) {
    var c = new Error();

    if (c.stack) {
      var l = c.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);
      l || (l = c.stack.match(/.*\n([A-Z][A-Za-z$]+)@/)), l && (i[q] = P(l[1]));
    }
  }

  o[1] = i;

  for (var u = 2; u < a; u++) {
    o[u] = n[u];
  }

  return t.apply(null, o);
},
    Z = function e(r) {
  for (var t = r.length, n = 0, a = ""; n < t; n++) {
    var o = r[n];

    if (null != o) {
      var i = void 0;

      switch (typeof o) {
        case "boolean":
          break;

        case "object":
          if (Array.isArray(o)) i = e(o);else for (var s in i = "", o) {
            o[s] && s && (i && (i += " "), i += s);
          }
          break;

        default:
          i = o;
      }

      i && (a && (a += " "), a += i);
    }
  }

  return a;
};

function B(e, r, t) {
  var n = [],
      a = d(e, n, t);
  return n.length < 2 ? t : a + r(n);
}

function F() {
  var e = o(["\n  ::before,\n  ::after {\n    ", ";\n    right: 50%;\n    width: 50%;\n    border-top: var(--tree-line-width) solid var(--tree-line-color);\n  }\n  ::after {\n    left: 50%;\n    border-left: var(--tree-line-width) solid var(--tree-line-color);\n  }\n\n  :only-of-type {\n    padding: 0;\n    ::after,\n    :before {\n      display: none;\n    }\n  }\n\n  :first-of-type {\n    ::before {\n      border: 0 none;\n    }\n    ::after {\n      border-radius: var(--tree-line-border-radius) 0 0 0;\n    }\n  }\n\n  :last-of-type {\n    ::before {\n      border-right: var(--tree-line-width) solid var(--tree-line-color);\n      border-radius: 0 var(--tree-line-border-radius) 0 0;\n    }\n    ::after {\n      border: 0 none;\n    }\n  }\n"]);
  return F = function F() {
    return e;
  }, e;
}

function H() {
  var e = o(["\n  flex: auto;\n  text-align: center;\n  list-style-type: none;\n  position: relative;\n  padding: var(--tree-line-height) var(--tree-node-padding) 0\n    var(--tree-node-padding);\n"]);
  return H = function H() {
    return e;
  }, e;
}

function J() {
  var e = o(["\n  display: flex;\n  padding-inline-start: 0;\n  padding-top: var(--tree-line-height);\n  position: relative;\n\n  ::before {\n    ", ";\n    left: 50%;\n    width: 0;\n    border-left: var(--tree-line-width) solid var(--tree-line-color);\n  }\n"]);
  return J = function J() {
    return e;
  }, e;
}

function K() {
  var e = o(["\n  content: '';\n  position: absolute;\n  top: 0;\n  height: var(--tree-line-height);\n  box-sizing: border-box;\n"]);
  return K = function K() {
    return e;
  }, e;
}

L(function (e, r) {
  return t(R.Consumer, null, function (t) {
    var n = !1,
        a = function a() {
      if (n && "production" !== process.env.NODE_ENV) throw new Error("css can only be used during render");

      for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++) {
        t[a] = arguments[a];
      }

      var o = j(t, r.registered);
      return h(r, o, !1), r.key + "-" + o.name;
    },
        o = e.children({
      css: a,
      cx: function cx() {
        if (n && "production" !== process.env.NODE_ENV) throw new Error("cx can only be used during render");

        for (var e = arguments.length, t = new Array(e), o = 0; o < e; o++) {
          t[o] = arguments[o];
        }

        return B(r.registered, a, Z(t));
      },
      theme: t
    });

    return n = !0, o;
  });
});
var Q = T(K()),
    X = T(J(), Q),
    ee = T(H()),
    re = T(F(), Q);

function te(e) {
  var r = e.children;
  return W("li", {
    css: [ee, re],
    className: e.className
  }, e.label, n.count(r) > 0 && W("ul", {
    css: X
  }, r));
}

function ne() {
  var e = o(["\n        padding-inline-start: 0;\n        margin: 0;\n        display: flex;\n\n        --line-height: ", ";\n        --line-width: ", ";\n        --line-color: ", ";\n        --line-border-radius: ", ";\n        --node-padding: ", ";\n\n        --tree-line-height: var(--line-height, 20px);\n        --tree-line-width: var(--line-width, 1px);\n        --tree-line-color: var(--line-color, black);\n        --tree-line-border-radius: var(--line-border-radius, 5px);\n        --tree-node-padding: var(--node-padding, 5px);\n      "]);
  return ne = function ne() {
    return e;
  }, e;
}

function ae(e) {
  var r = e.children,
      t = e.label,
      n = e.lineHeight,
      a = void 0 === n ? "20px" : n,
      o = e.lineWidth,
      i = void 0 === o ? "1px" : o,
      s = e.lineColor,
      c = void 0 === s ? "black" : s,
      l = e.nodePadding,
      u = void 0 === l ? "5px" : l,
      d = e.lineBorderRadius,
      f = void 0 === d ? "5px" : d;
  return W("ul", {
    css: T(ne(), a, i, c, f, u)
  }, W(te, {
    label: t
  }, r));
}

var oe = a(ae);
export { oe as Tree, te as TreeNode };